<template>
    <div class="inp-s-wrap inp-select full" :class="[{ opened: focused, active: focus, fill: showLabel , error: isError, 'repeat-error':  repeatError, disabled: disabled}, addClass]" v-clickoutside="selectClose">
        <div class="select-overlay" @click="selectToggle"></div>
        <span class="inp-s-label" :class="{error: isError, 'repeat-error':  repeatError }">{{placeholder}}</span>

        <input :class="{error:isError, 'repeat-error':  repeatError }" type="text" v-model="keywords" name="" class="inp-s" :disabled="true">


        <div class="select-arrow"></div>
        <div class="select-list" :style="listStyle">
            <ul v-if="focus">
                <li v-for="i in 24" :key="i" class="fs-item"
                    @click="change(i)" :class="{active: i === choosen}">
                    <span class="i i-ok2" v-if="keywords == value"></span>
                    <span><span v-if="i < 11">0</span>{{i-1}}:00</span>
                </li>
            </ul>
            <ul class="select-list --ghost" v-show="false">
                <li>
                    <div></div>
                </li>
                <li>
                    <div></div>
                </li>
                <li>
                    <div></div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>

    export default {
        name: 'InputSelect',
        components: {},
        props: {
            tag: {default: ''},
            addClass: {default: ''},
            isError: {default: false},
            listStyle: {default: ''},
            value: {default: ''},
            placeholder: {default: ''},
            valueIndex: {default: ''},
            modelId: {default: 0},
            disabled: {default: false}
        },
        model: {
            prop: 'modelId',
            event: 'change'
        },
        data: function () {
            return {
                keywords: '', //Слежение за инпутом
                resopened: false, //Отвечает за видимость списка результатов быстрого поиска
                choosen: null,
                focus: false,
                repeatError: false,
            }
        },
        mounted() {
            this.keywords = this.value < 10 ? '0' + this.value + ':00' : this.value + ':00';
        },
        watch:{
            value(){
                this.keywords = this.value < 10 ? '0' + this.value + ':00' : this.value + ':00';
            },
            keywords(){
                this.$emit('input',this.keywords);
            },
            valueIndex(){
                if(this.valueIndex != ''){
                    this.change(this.valueIndex * 1);
                }else{
                    this.keywords = '';
                    this.choosen = null;
                }
            },
            isError(val,oldVal){
                if(oldVal){
                    this.repeatError = true;
                }
            },
            modelId(after){
                let option = this.options.find(option => option.id == after);
                this.keywords = option ? option.name : '';
            }
        },
        computed: {
            focused() {
                return this.focus
            },
            showLabel() {
                return this.keywords.toString().length > 0;
            },
        },
        methods: {
            selectToggle(){
                this.focus = !this.focus;
                this.$emit('open', this.focus);
            },
            change: function(index){
                this.keywords = index - 1 < 10 ? '0' + (index - 1) + ':00' : (index - 1)+ ':00';;
                this.focus = false;
                this.repeatError = false;
                this.choosen = index;
                this.$emit('change', index - 1);
            },
            selectClose: function () {
                this.focus = false;
            },
        },
        directives: {
            'clickoutside': {
                mounted: function(el, binding, vNode) {
                    if (typeof binding.value !== 'function') {
                        const compName = vNode.context.name;
                        let warn = `[Vue-click-outside:] provided expression '${binding.expression}' is not a function, but has to be`
                        if (compName) { warn += `Found in component '${compName}'` }
                        //console.warn(warn);
                    }
                    const bubble = binding.modifiers.bubble;
                    const handler = (e) => {
                        if (bubble || (!el.contains(e.target) && el !== e.target)) {
                            binding.value(e)
                        }
                    }
                    el.__vueClickOutside__ = handler;
                    document.addEventListener('click', handler);
                },

                unmounted: function(el, binding) {
                    document.removeEventListener('click', el.__vueClickOutside__);
                    el.__vueClickOutside__ = null;
                }
            }
        }
    }
</script>

<style lang="css">

</style>
